export default __webpack_public_path__ + "static/Roboto-Bold-6dafca5a4f1e31f2bdf11939b24ff422.ttf";